module.exports = __webpack_public_path__ + "static/media/tree-step-5_1.9f961fbe.svg";